import { Component, ViewChild, OnInit, Input, Output, EventEmitter,  ChangeDetectorRef, SimpleChanges, ElementRef } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { CoreVm, AddCoreVm, AddContactVm, AddCompanyVm, FileModelVM } from 'src/app/viewModels/core/core-vm';

@Component({
  selector: 'app-addnew',
  templateUrl: './addnew.component.html',
  styleUrls: ['./addnew.component.scss'] 
})

export class AddNewComponent implements OnInit {

  @Input() modulename: string;
  @Input() mainModuleName: string;  
  @Input() name: string;                   
  @Input() coreID:number=0; 
  @Input() contactID:number=0;   
  @Input() isShared:boolean=false; 
  @Input() formFolderID:number;
  @Input() formIDSendToAPI: number;
  @Input() fileManagerItemID:number;
  @Input() aiDetails: any=[]=[];  
  @Input() SendingFor: string;
  addressValue:any;
  cityValue: string="";
  stateValue: string="";
  zipValue: string="";
  grpToggle: boolean = true;
  close: boolean = false;
  checkboxStatus: boolean = false;
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  coreFieldList: any;
  coreFieldListForType: any;
  coreFieldSaveCompare: any;
  coreFieldSaveCompareForType: any;
  coreFieldListSubmit: any;
  myFormGroup: FormGroup;
  addressFormGroup: any=[];
  dynamicArray: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;
  ImageUploadURL: any = '';
  imagelist: any;
  dropdownlist: any;
  dropdownlistType: any;
  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;

 

  chkStatusArry: any;
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  @Output() closeAdd = new EventEmitter<boolean>();
  @Output() contactSaved = new EventEmitter<boolean>();
  @Output() companySaved = new EventEmitter<boolean>();
  @Output() sendContactId = new EventEmitter();

  tempValue: any;
  TypeList: any = [];
  step = 0;


  AllTypeList: any = [];
  selectedTypeList: any;

  fieldsList: any[] = [];
  selectedTypefieldsList: any[] = [];
  getSubFolderFieldsListResponseHolder: any;
  getTagListResponseHolder: any;
  getSubFolderFieldsModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    subFolderID: 0,
    fieldID: 0
  };
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize:0
  };
  CityModel = {
    Name: '',
    databaseID: 0,
    userID:''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID:''
  };

  
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  TypeListForDropDown: any = [];


  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  
  cityOption: string[]=[];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[] = [];
  allTags: string[] = [];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  clickEventsubscription: Subscription;
  arryaControlNameIdpare: any=[];
  tagvalues: string;
  zipOption: any[];
  stateList: any[];
  folderId:number=0;
  folderList: any[] = [];
  modulenameinternal: string;
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
  getPDPMStagesList: any[] = [];
  medicalCategoryID:number=0;
  ProcessStageListForDropDown: any[] = [];

  constructor(private loaderService: LoaderService, private cdr: ChangeDetectorRef,
    private _dataSharingService: DataSharingService, private router: Router,    
    private reusableClass: ReusableClasses, private encryptionAlgo: EncryptionService,
    private fileModelVM: FileModelVM, private statusConst: StatusConstant,      
    private coreService: CoreService, private settingsService: SettingService,
    private formBuilder: FormBuilder, private toastr: ToastrService,
    private coreVm: CoreVm, private addCoreVm: AddCoreVm,
    private addContactVm: AddContactVm,private addCompanyVm: AddCompanyVm) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {

      this.EmaildArray=[];
      this.name;

      if(this.name!=undefined){
       // Remove last comma with optional space(s)
       this.name = this.name.replace(/,\s*$/, '');
      }

      this.modulename;
      this.coreID;
      this.mainModuleName;     

      this.formFolderID;
      this.formIDSendToAPI;
     
      this.aiDetails;

      let group = {};
      this.myFormGroup = new FormGroup(group);
      this.myFormGroup.patchValue({
        Name: this.name
       });
       

      var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
      var check = menuModulesList.filter(x => x.orgModuleName == this.modulename);
      if(check.length>0){
        this.modulenameinternal = check[0].mainModuleName;
      }     
      this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));
      if(this.modulenameinternal == "Core"){
        var data= this.folderList.filter(x => x.mainModuleName === "Core");
        this.folderId=data[0].folderID;       
      }
      if(this.modulenameinternal == "Contact"){
        var data= this.folderList.filter(x => x.mainModuleName === "Contact");
        this.folderId=data[0].folderID;      
      }
      if(this.modulenameinternal == "Company"){
        var data= this.folderList.filter(x => x.mainModuleName === "Company");
        this.folderId=data[0].folderID;
      }       

      const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
      this.coreFieldSaveCompareForType = [];
      this.coreFieldListForType=[];
      this.dynamicArray = [];
      this.dynamicArrayPhone = [];
      this.dynamicArrayAddress = [];
      this.dynamicArrayWebsite = [];
      this.getAllFolderFields();
      this.getAllTagsList();   
      this.getStateDropdownList(231);    
      this.getPDPMStageslist();
      this.getDashboardProcessStages();
      this.loaderService.hide();
      this.cdr.detectChanges();
  }

  ngOnInit(): void {  
    // this.EmaildArray=[];
    // const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    // this.coreFieldSaveCompareForType = [];
    // this.coreFieldListForType=[];
    // this.dynamicArray = [];
    // this.dynamicArrayPhone = [];
    // this.dynamicArrayAddress = [];
    // this.dynamicArrayWebsite = [];
    // this.getAllFolderFields();
    // this.getAllTagsList();
    // let group = {};
    // this.myFormGroup = new FormGroup(group);
    // this.getStateDropdownList(231);
  }

  getPDPMStageslist() {
    var ReqModel = {
      categoryID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getPDPMStage(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.getPDPMStagesList = response.data;
        } else {
          this.getPDPMStagesList = [];
        }
      } else {
        this.getPDPMStagesList = [];
      }
    });
  }

   getDashboardProcessStages() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.settingsService.getDashboardProcessStages(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess && response.data != null) {
          this.ProcessStageListForDropDown = response.data;
        } else {
          this.ProcessStageListForDropDown = [];
        }
      } else {
        this.ProcessStageListForDropDown = [];
      }
    });
  }

  CheckName(val){
    if(val.trim()=="" || val.trim()==undefined || val.trim()==null || val.trim()=="-" ){
      this.myFormGroup.controls['Name'].setErrors({'incorrect': true}); 
      return;
    } 
    if (val.toLowerCase() != val.toLowerCase().match('^[a-z0-9_%+-]+@[a-z0-9-]+\\[a-z]{2,4}$')&& val.indexOf('@') == -1){     
     }else{
      this.myFormGroup.controls['Name'].setErrors({'incorrect': true});    
     }
  }
  
  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check=[];
    check= this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if(check.length>0){
     this.fruitCtrl.setValue(null);
     return;
    }  
    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());

      if (index >= 0) {       
      }
      else {
        this.tags.push(event.value.trim());
      }

    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';     
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  // get Tag List
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;         
        }
        else {
          this.allTags=[];
        }
      }
    });
  }
  
  states: string[] = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
    'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
    'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
    'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  searchZip(zip :any) {
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {         
           this.zipOption=[];
           response.data.forEach(element => {
           this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name :any){ 
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {          
          this.cityOption=[];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId:any) {
    if (countryId!=undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
          if (response!=undefined) {
            if (response.status == this.statusConst.statusSuccess) {
              this.stateList = [];
              if(countryId == 231 || countryId == 38){               
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              } 
            }
          }
        });
    }
  }

  numberOnly(event: KeyboardEvent): boolean {
  const charCode = event.which ? event.which : event.keyCode;

  // Allow: Backspace, Tab, Delete, Left, Right arrows
  if ([8, 9, 46, 37, 39].includes(charCode)) {
    return true;
  }

  // Allow numbers (0-9)
  if (charCode >= 48 && charCode <= 57) {
    return true;
  }

  // Allow decimal point (.)
  if (charCode === 46) {
    // Prevent more than one decimal point
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.includes('.')) {
      return false;
    }
    return true;
  }

  return false;
  }

  
  // numberOnly(event): boolean {
  //   const charCode = event.which ? event.which : event.keyCode;
  //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //     return false;
  //   }
  //   return true;
  // }

  addMore(fieldName: any) {
    if (fieldName == 'Email') {
      let length = this.dynamicArray.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

        if(ctrl!=undefined){
       let plcHolder = ctrl.fieldNames[0].fieldName;

       if (ctrl) {
        var field = {
        fieldID: ctrl.fieldID,
        fieldName: fieldName,
        fieldNames: ctrl.fieldNames,
        fieldTypeID: ctrl.fieldTypeID,
        fieldTypeName: ctrl.fieldTypeName,
        folderID: ctrl.folderID,
        isRequired: ctrl.isRequired,
        placeholder: ctrl.placeholder,
        position: ctrl.position,
        placeholderVal: plcHolder != null ? plcHolder : '',
        fieldNameEmail:fieldName+length,
        isPrimary:false
      };
      this.dynamicArray.push(field);
     }
    }      
    }
    // Phone
    if (fieldName == 'Phone') {
      let length = this.dynamicArrayPhone.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          this.dynamicArrayPhone.push(formControl);
        }
      });
    }
    //Address
    if (fieldName == 'Address') {
      let length = this.dynamicArrayAddress.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      

      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      
      this.myFormGroup.addControl(
        'City' + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        'State' + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        'ZipCode' + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        'Country' + length,
        this.formBuilder.control('')
      );     


      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          this.dynamicArrayAddress.push(formControl);
        }
      });
    }
    //Website
    if (fieldName == 'WebSite') {
      let length = this.dynamicArrayWebsite.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          this.dynamicArrayWebsite.push(formControl);
        }
      });
    }
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }


  // get all created Feilds
  getAllFolderFields() {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;    
    var reqModel={
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),     
      folderID : this.folderId,//17;
      subFolderID: 0,
      fieldID: 0,
      requestFrom: 0,
      officeID:this.myOfficeID,
	    OfficeIDList:this.OfficeIDList
    } 
    this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreFieldSaveCompare = response.data.activeFields.filter((m) => m.fieldID > 0);
          this.coreFieldSaveCompareForType = response.data.activeFields.filter((m) => m.fieldID > 0);

          this.coreFieldList = response.data.activeFields;
          this.coreFieldList.forEach(e => {
            if(e.fieldName=="Email") {
              e.isPrimary=true
            }
           });
           var check = this.coreFieldList.filter((m) => m.fieldID ==0);
           if(check.length>0){
            this.coreFieldList.map(e => {
              if(e.fieldID==0 && e.data.length > 0) {
                 e.data.map(e1 => {
              if(e1.fieldName=="Email") {
                e1.isPrimary=true                
              }
              return e1;
              });               
              }
             });

           }

          this.AllTypeList = response.data.types;
          this.AllTypeList.splice(0,0,{folderName: "Select",
          isChecked: false,
          subFolderID: 0});
         
          var NewList;
          var NewListMedicalCategory;
          NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          NewListMedicalCategory = response.data.activeFields.filter((s) => s.fieldName !== 'PDPM category');
          var type:any=[]=[];
          type = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
          if(type.length>0){
           NewList.splice(1, 0, type[0]);
           this.coreFieldList = NewList;
          }        
                   
          var MedicalCategory:any=[]=[];
          MedicalCategory = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'PDPM category');
          if(MedicalCategory.length>0){          
           NewListMedicalCategory.splice(2, 0, MedicalCategory[0]);
           this.coreFieldList = NewListMedicalCategory;
          }         

          this.imagelist = this.coreFieldList.filter((e) => e.fieldTypeName == 'Image');
          this.coreFieldList = this.coreFieldList.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldList = this.coreFieldList.filter((s) => s.isActive == true);
          this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
          this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2); 
        
          this.coreFieldListForType = this.coreFieldList;

          const Fields = {};
          this.coreFieldList.forEach((formControl) => {
            if (formControl.fieldID == 0 && formControl.data.length > 0) {
              formControl.data.forEach((ctrlgrp,) => {
                if (ctrlgrp.fieldID > 0) {
                  this.coreFieldSaveCompare.push(ctrlgrp);
                  if (ctrlgrp.fieldName == 'Phone')
                    Fields[ctrlgrp.fieldName] = new FormControl(
                      '',
                      Validators.pattern(phoneNumberregex)
                    );
                  else
                  {
                    Fields[ctrlgrp.fieldName] = new FormControl('');
                  }
                  if (ctrlgrp.fieldNames.length > 0) {
                    const toSelect = ctrlgrp.fieldNames[0];
                    this.tempValue = toSelect;
                    Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                  }
                }
              });
            }
            else {
              if (formControl.fieldName == 'Phone')
                Fields[formControl.fieldName] = new FormControl(
                  '',
                  Validators.pattern(phoneNumberregex)
                );
              else Fields[formControl.fieldName] = new FormControl('');

              if (formControl.fieldNames.length > 0) {
                const toSelect = formControl.fieldNames[0];
                this.tempValue = toSelect;
                Fields[formControl.fieldName + 'option'] = new FormControl();
              }
            }
          });
          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
            // address computaion array for computation
      this.addressFormGroup.push('Address');
      this.addressFormGroup.push('City');
      this.addressFormGroup.push('State');
      this.addressFormGroup.push('ZipCode');
      this.addressFormGroup.push('Country');
     
      this.myFormGroup = new FormGroup(Fields);

      // Check for Without Group //
       this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
       this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
       this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

       var data = [];

       data=this.coreFieldList.filter((s) => s.fieldID ==0);

       if (data.length > 0) {
         for (var i = 0, len = data.length; i < len; ++i) {
           var DrpData = [];
           DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
           if(DrpData.length>0){
             for (var v = 0, char = DrpData.length; v < char; ++v) {
               this.dropdownlist.push(DrpData[v]);
             }
           }
          
           var MultiData=[];
           MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
           if(MultiData.length>0){
             for (var v = 0, char = MultiData.length; v < char; ++v) {
               this.multipleDropdownList.push(MultiData[v]);
             }
           }
           
           var CheckboxData=[];
           CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
           if(CheckboxData.length>0){
             for (var v = 0, char = CheckboxData.length; v < char; ++v) {
               this.checkBoxList.push(CheckboxData[v]);
             }
           }
          
         }
       }               
      
       if (this.dropdownlist.length > 0) {
         var fieldListdrp = [];
         var value;
         var valueArray;
         for (let i = 0; i < this.dropdownlist.length; i++) {
            var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
            //value = drpValue.split(',');
            valueArray = drpValue.split(',').map(item => item.trim());

           var FieldsDrp = {
             FieldValue: this.dropdownlist[i].fieldName,
             value: valueArray
           };
           fieldListdrp.push(FieldsDrp);
         }
         this.dropdownlist = fieldListdrp;
       }

       if (this.multipleDropdownList.length > 0) {
         var fieldmulListdrp = [];
         var value;
         for (let i = 0; i < this.multipleDropdownList.length; i++) {
           var multidropValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
           value = multidropValue.split(',');
          
           var FieldsMulDrp = {
             FieldValue: this.multipleDropdownList[i].fieldName,
             value: value,
           };
           fieldmulListdrp.push(FieldsMulDrp);
         }
         this.multipleDropdownList = fieldmulListdrp;
       }

       if (this.checkBoxList.length > 0) {
         var fieldcheckbox = [];
         var value;
         for (let i = 0; i < this.checkBoxList.length; i++) {
           var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
           value = checkboxValue.split(',');
           var FieldsCheckbox = {
             FieldValue: this.checkBoxList[i].fieldName,
             value: value,
           };
           fieldcheckbox.push(FieldsCheckbox);
         }
         this.checkBoxList = fieldcheckbox;
       }
           
       if (this.aiDetails.length > 0) {
        this.coreFieldList.forEach((formControl) => {
          let fieldValueDetails = [];
      
          if (formControl.fieldID === 0) {
            const groupFields = formControl.data.filter(x => x.fieldID > 0);
            if (groupFields.length > 0) {
              groupFields.forEach((groupField) => {
                // const fieldValueDetails = this.aiDetails.filter(x => x.fieldID === groupField.fieldID);
               // const fieldValueDetails = this.aiDetails.filter(x => x.fieldName === groupField.fieldName);
             const fieldValueDetails = this.aiDetails.filter(x => x.fieldName === groupField.fieldName || 
                            (x.formFieldName != null && x.formFieldName !== '' && x.formFieldName === groupField.fieldName));
                   
               if (fieldValueDetails.length > 0) {
                  this.setFieldValue(groupField, fieldValueDetails[0]);
                }
              });
            }         
            }else {

           // fieldValueDetails = this.aiDetails.filter(x => x.fieldID === formControl.fieldID);
           // fieldValueDetails = this.aiDetails.filter(x => x.fieldName === formControl.fieldName);
           fieldValueDetails= this.aiDetails.filter(x => x.fieldName === formControl.fieldName || 
                            (x.formFieldName != null && x.formFieldName !== '' && x.formFieldName === formControl.fieldName));

            if (fieldValueDetails.length > 0) {
              this.setFieldValue(formControl, fieldValueDetails[0]);
            }
            
          }
        });
       }        
       }
       this.myFormGroup.markAsDirty();
      }
    });
  }
  
  // setFieldValue(formControl, fieldValueDetail) {
  //   if (formControl.fieldTypeName === 'Date') {     
  //     formControl.fieldValue = this.convertToUTCDate(fieldValueDetail.value);
  //   } else {     
  //     formControl.fieldValue = fieldValueDetail.value;
  //   }
  // }

  setFieldValue(formControl, fieldValueDetail) {
  if (formControl.fieldTypeName === 'Date') {
    formControl.fieldValue = this.convertToUTCDate(fieldValueDetail.value);
  } else if (formControl.fieldTypeName === 'Dropdown') {
      if(formControl.fieldName.toLowerCase()=="sex".toLowerCase() || formControl.fieldName.toLowerCase()=="gender".toLowerCase()){
      if(fieldValueDetail.value.toLowerCase()=='m'.toLowerCase() || fieldValueDetail.value.toLowerCase()=='ma'.toLowerCase() || fieldValueDetail.value.toLowerCase()=='mal'.toLowerCase()){
        fieldValueDetail.value="Male";
      }
      if(fieldValueDetail.value.toLowerCase()=='f'.toLowerCase() || fieldValueDetail.value.toLowerCase()=='fe'.toLowerCase() || fieldValueDetail.value.toLowerCase()=='fem'.toLowerCase() ||fieldValueDetail.value.toLowerCase()=='fema'.toLowerCase() || fieldValueDetail.value.toLowerCase()=='femal'.toLowerCase()){
        fieldValueDetail.value="Female";
      }
     }
    formControl.fieldValue = this.DropdownSetValue(formControl,fieldValueDetail);
  } else {
    if (formControl.fieldName === 'Address') {
      if (fieldValueDetail.value !== "") {
        this.runAIButton_4o_onGivenContext(fieldValueDetail.value, formControl);
      }
    } else {
      formControl.fieldValue = fieldValueDetail.value;
    }
  }
}


  // getddlSelectedVal(fieldName,fieldValue) {
  //   if (this.dropdownlist) {
  //     var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
  //     if (_newdropdownlist[0] && _newdropdownlist[0].fieldValue != '' && _newdropdownlist[0].fieldValue != undefined && _newdropdownlist[0].fieldValue != null) {
  //       return _newdropdownlist[0].fieldValue;
  //     } else {
  //       return '';
  //     }
  //   }
  // }

 getddlSelectedVal(fieldName,fieldValue) {
    if (fieldValue) {
     return fieldValue;
    }else{
      return '';
    }
  }

  DropdownSetValue(formControl,fieldValueDetail){
    const defaultValue = formControl?.defaultValue ?? '';

    //formControl.defaultValue= formControl.defaultValue?.trim().replace(/\s*,\s*/g, ',');

     // Ensure it's a string and split it
    const separatedArray: string[] = defaultValue
    .split(',')
    .map(item => item.trim())
    .filter(item => item !== ''); // Optional: remove empty items

     // Perform case-insensitive comparison
     const match = separatedArray.find(item => item.trim().toLowerCase() === fieldValueDetail?.value?.trim().toLowerCase());

     return match ?? ''; 
  }

  
  runAIButton_4o_onGivenContext(addressValue,formControl) {
    let instructionString = `Given a single text containing a US address, extract and return the following fields as a JSON object:  
          \addressLine1\ (first line of the address)  
          \city\ (city name)  
          \state\ (must be converted to its 2-letter abbreviation from the provided list, case-insensitive)  
          \zipcode\ (5-digit or 5+4 ZIP code)  

         **Rules:**  
          The \state\ must strictly match one of these abbreviations (case-insensitive):  
          \AL, AK, AZ, AR, CA, CO, CT, DE, DC, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY\  
          If the state is given as a full name (e.g., "California"), convert it to its abbreviation ("CA").  
          If no valid state is found, set \state\ to \null\.  
          If any field cannot be extracted, set it to \null\.  
          Return **only the JSON object** with no additional text or explanations.  

          **Example Input:**  
            "123 Main St, Los Angeles, California 90001"  

          **Expected Output:**  
           {"addressLine1": "123 Main St", "city": "Los Angeles", "state": "CA", "zipcode": "90001"}  

           Now process this ADDRESS input: ${addressValue}`;          
           this.coreService.submit_prompt_4o_onGivenContext_New({prompt:instructionString}).subscribe(response => {
        
                         
          if (response && response.status == this.statusConst.statusSuccess) {
              
         //response.data  =  response.data.filter((x) => x.abbreviation != null);
                // Extract JSON from AI's response (handling edge cases)
         let jsonStringNew = response.data;
         let jsonStart = jsonStringNew.indexOf('{');
         let jsonEnd = jsonStringNew.lastIndexOf('}') + 1;
         let jsonString = jsonStringNew.slice(jsonStart, jsonEnd);
         let addressObj=JSON.parse(jsonString);
         //To do logic to map core fields        
         if(addressObj.addressLine1!=null){
          formControl.fieldValue=addressObj.addressLine1;
         }
         if(addressObj.city!=null){
          this.cityValue=addressObj.city;
         }
         if(addressObj.state!=null){
          this.stateValue=addressObj.state;
         }
         if(addressObj.zipcode!=null){
          // this.zipValue=addressObj.zipcode;
          const zip = addressObj.zipcode?.toString().match(/^\d{1,5}/);//addressObj.zipcode?.toString().match(/^\d{5}/);
          this.zipValue = zip ? zip[0] : "";
         }
            
        } else {
                
        }
      },
      error => {
             
      }
    );
  }
  

  convertToUTCDate(dateString: string): Date | string {
    if (!dateString) return '';

    // Split the date and time parts by 'T'
    const [datePart] = dateString.split('T');
    const [month, day, year] = datePart.split('/').map(Number)
    //const [year, month, day] = datePart.split('/').map(Number)
    const date= new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
    //let newUTCDate=this.formatAsUTC(date); 
    if (isNaN(date.getTime())){
      if (!dateString) return '';
    }else{
      return date;
    }    
  }


  getSubFolderFields(event, fieldName) {
    if (event != undefined && fieldName == "Type") {  
      var reqModel={
        userID : this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),     
        folderID : this.folderId,//17;
        subFolderID: 0,
        fieldID: 0,
        requestFrom: 0,
        officeID:this.myOfficeID,
	      OfficeIDList:this.OfficeIDList
      } 
      this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.coreFieldSaveCompareForType = response.data.activeFields.filter((m) => m.fieldID > 0);
          }
          this.coreFieldListForType = response.data.activeFields.filter((s) => s.fieldTypeName != 'Image');

          var NewList;
          NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);          
          this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.isActive == true);         
        }
        this.getTypeFieldList(event);
      });
    }
  }

  getTypeFieldList(event){
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.typeId = event.value;  
    var reqModel={
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),     
      folderID : this.folderId,//17;
      subFolderID: this.typeId,
      fieldID: 0,
      requestFrom: 0,
      officeID:this.myOfficeID,
	    OfficeIDList:this.OfficeIDList
    } 
    this.settingsService.getAllFieldsCore(reqModel).subscribe(response => {
      if (response != undefined) {
        this.getSubFolderFieldsListResponseHolder = response;
        if (this.getSubFolderFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
          this.fieldsList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter(s => s.fieldTypeName != 'Image');
                   
          this.AllTypeList = this.getSubFolderFieldsListResponseHolder.data.types;
          this.AllTypeList.splice(0,0,{folderName: "Select", isChecked: false,subFolderID: 0});
          

          this.coreFieldListForType = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldTypeName != 'Image');

          this.coreFieldListForType =this.fieldsList;
          this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
         // this.coreFieldList = this.coreFieldListForType;

          var NewList;
          NewList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);          
          this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.isActive == true);  
       

          this.selectedTypefieldsList = this.fieldsList.filter(({ fieldID: id1 }) => !this.coreFieldList.some(({ fieldID: id2 }) => id2 === id1));
          this.selectedTypefieldsList = this.selectedTypefieldsList.filter((s) => s.fieldID > 0);

          var tempArryacoreFieldList=[];
          tempArryacoreFieldList=this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((m) => m.fieldID == 0);

          if(tempArryacoreFieldList.length>0){
           var check= this.coreFieldList.filter(({ position: id1 }) => !this.fieldsList.some(({ position: id2 }) => id2 === id1));
           if(check.length==0){
            tempArryacoreFieldList=[];
           }
          }
          
          this.dropdownlist = this.fieldsList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.fieldsList.filter((s) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.fieldsList.filter((s) => s.fieldTypeName == 'Checkbox');

          var data = [];
          this.arryaControlNameIdpare=[];
          data=this.fieldsList.filter((s) => s.fieldID ==0);        

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
              if(DrpData.length>0){
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }
             
              var MultiData=[];
              MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
              if(MultiData.length>0){
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }
              
              var CheckboxData=[];
              CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
              if(CheckboxData.length>0){
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }             
            }
          }               

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              var valueArray;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                 var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
                //value = drpValue.split(',');
                 valueArray = drpValue.split(',').map(item => item.trim());

                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: valueArray
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value.trim(),
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }   
           

             // Modified array containing group starts
             tempArryacoreFieldList.forEach(element => {
              if(element.data.length>1) {
                var indexArray=[];
                
                element.data.forEach(elementin => {
                  if(elementin.fieldID>0){
                    let grpele=this.coreFieldList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                    elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
                    elementin.id=grpele!=undefined?grpele.id:0;
                    elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
                    if(elementin.fieldNames.length>0){
                      if(grpele!=undefined){
                        elementin.fieldNameID=grpele.fieldNameID;
                        elementin.placeholderVal=grpele.placeholderVal; 
                      }                                          
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)){
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreFieldList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                    indexArray.push(index);
                  }
                });                 
               
                this.coreFieldList = this.coreFieldList.filter(function(value, index) { 
                  return indexArray.indexOf(index) == -1; 
                });
                this.coreFieldList.splice(indexArray[0],0,element);                
              }
            });
          

          if (this.selectedTypefieldsList.length == 0) {
            this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
            this.coreFieldList = this.coreFieldListForType;

            this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
            this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2); 

            const Fields = {};
            this.coreFieldList.forEach((formControl) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl(
                        '',
                        Validators.pattern(phoneNumberregex)
                      );
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl(
                    '',
                    Validators.pattern(phoneNumberregex)
                  );
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            });
          }

          this.arryaControlNameIdpare=[];

            if (this.selectedTypefieldsList.length > 0) {
            for (let i = 0; i < this.selectedTypefieldsList.length; i++) {
              this.coreFieldSaveCompare.push(this.selectedTypefieldsList[i]);            
              this.arryaControlNameIdpare.push({
                name:this.selectedTypefieldsList[i].fieldName,
                id:this.selectedTypefieldsList[i].id,
                subfolderID:this.selectedTypefieldsList[i].subfolderID
              });
              var index = this.fieldsList.findIndex(x=>x.fieldName==this.selectedTypefieldsList[i].fieldName && x.fieldID==this.selectedTypefieldsList[i].fieldID);
              this.coreFieldList.splice(index,0,this.selectedTypefieldsList[i]);
            }                           

            this.selectedTypefieldsList.forEach((formControl) => {
              this.myFormGroup.addControl(formControl.fieldName, this.formBuilder.control(''));
            });

            const Fields = {};
            this.coreFieldList = this.coreFieldListForType;
            
            this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
            this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2);

            this.coreFieldList.forEach((formControl) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl('', Validators.pattern(phoneNumberregex));
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl('',Validators.pattern(phoneNumberregex));
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            }); 
            if (this.aiDetails.length > 0) {
              this.coreFieldList.forEach((formControl) => {
                let fieldValueDetails = [];
            
                if (formControl.fieldID === 0) {
                  const groupFields = formControl.data.filter(x => x.fieldID > 0);
                  if (groupFields.length > 0) {
                    groupFields.forEach((groupField) => {
                      const fieldValueDetails = this.aiDetails.filter(x => x.fieldID === groupField.fieldID);
                      if (fieldValueDetails.length > 0) {
                        this.setFieldValue(groupField, fieldValueDetails[0]);
                      }
                    });
                  }         
                  }else {
      
                  fieldValueDetails = this.aiDetails.filter(x => x.fieldID === formControl.fieldID);
            
                  if (fieldValueDetails.length > 0) {
                    this.setFieldValue(formControl, fieldValueDetails[0]);
                  }
                  
                }
              });
            }
          }
          else {
          }
        }
      }
    });
    
  }

  getdropdownlist(fieldName) {
    var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
    return _newdropdownlist[0].value;
  }

  getMuldropdownlist(fieldName) {
    var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
    return _newMuldropdownlist[0].value;
  }

 

  getCheckBoxlist(fieldName) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    return _newcheckBoxlist[0].value;
  }

   OnChange($event: any, chk: any, fieldId: any) {
    this.myFormGroup.get(chk).markAsDirty();
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {     
      if(this.chkStatusArry.length>0){
       var checkRecord=[];
       checkRecord = this.chkStatusArry.filter(x=>x.fieldId==fieldId);
       if(checkRecord.length>0){
       this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = chk;
       }
      }else{
       this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
       });
      }    
    } else {
      if(this.chkStatusArry.length>0){
        this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = '';
      } 
      // if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
      //   this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
      // }
    }
  }
  
  // OnChange($event: any, chk: any, fieldId: any) { 
  //   let ckhchecked = [];
  //   if (!this.chkStatusArry) {
  //     this.chkStatusArry = [];
  //   }
  //   if ($event.checked) {
  //     this.chkStatusArry.push({
  //       ckh: chk,
  //       fieldId: fieldId,
  //     });
  //   } else {
  //     if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
  //       this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
  //     }
  //   }
  // }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.ImageUploadURL = response.data;
          }
        }
      });
  }


  check:boolean= false;
  isPrimary:boolean= false;
  EmaildArray:any=[];
  makeactiveParent:boolean=true;
  makeactivechild:boolean=false;

  MakePrimaryChild($event:any,field: any) {
    this.coreFieldList.field;
    this.makeactiveParent=false;
    this.makeactivechild=true;
    this.coreFieldList.forEach(e => {
      if(e.fieldName=="Email") {
        e.isPrimary=false
      }
     });
     this.coreFieldList.map(e => {
      if(e.fieldID==0 && e.data.length > 0) {
         e.data.map(e1 => {
      if(e1.fieldName=="Email") {
        e1.isPrimary=false                
      }
      return e1;
       });               
      }

     });
   
    this.cdr.detectChanges();
    this.myFormGroup.get(field.fieldName).markAsDirty();
    this.coreFieldList;
    this.check = false;
    this.dynamicArray.forEach(e => {
     if(e.fieldNameEmail==field.fieldNameEmail) {
       e.isPrimary=true;
     }else {
       e.isPrimary=false;
     }
    });

      var check = this.EmaildArray.filter((s) => s.fieldName == field.fieldName);
       if(check.length == 0){
        var ReqModels={
          fieldID:field.fieldID,
          fieldName:field.fieldNameEmail,
          fieldValue:field.fieldValue,
          isPrimary:true
        }
        this.EmaildArray.push(ReqModels);
       }    else{
        this.EmaildArray.find((item) => item.fieldName == field.fieldNameEmail).isPrimary = true;
        this.EmaildArray.find((item) => item.fieldName == field.fieldNameEmail).fieldValue = field.fieldValue;
        this.EmaildArray.forEach(e => {
          if(e.fieldName==field.fieldNameEmail) {
            e.isPrimary= true//$event.checked;
          }else {
            e.isPrimary=false;
          }
         });
     
       } 

   }


   MakePrimaryParent($event:any,field: any) {
    this.makeactiveParent=true;
    this.makeactivechild=false;
    this.coreFieldList.forEach(e => {
      if(e.fieldName=="Email") {
        e.isPrimary=true
      }
     });
     this.coreFieldList.map(e => {
      if(e.fieldID==0 && e.data.length > 0) {
         e.data.map(e1 => {
      if(e1.fieldName=="Email") {
        e1.isPrimary=true                
      }
      return e1;
       });               
      }
     });   

    this.cdr.detectChanges(); 
    this.myFormGroup.get(field.fieldName).markAsDirty();
    this.coreFieldList;
      this.dynamicArray.forEach(e => {     
        e.isPrimary=false;
     }); 
      var check = this.EmaildArray.filter((s) => s.fieldName == field.fieldName);
       if(check.length == 0){
        var ReqModels={
          fieldID:field.fieldID,
          fieldName:field.fieldName,
          fieldValue:field.fieldValue,
          isPrimary: true
        }
        this.EmaildArray.push(ReqModels);
       } else{
        this.EmaildArray.find((item) => item.fieldName == field.fieldName).isPrimary = true;
        this.EmaildArray.find((item) => item.fieldName == field.fieldName).fieldValue = field.fieldValue;

        this.EmaildArray.forEach(e => {
          if(e.fieldName==field.fieldName) {
            e.isPrimary=true;
          }else {
            e.isPrimary=false;
          }
         });
     
       }  

       
   }


  onSubmit(formValues: any,form) {
    if(this.modulenameinternal == "Core") {
      this.SaveCoreData(formValues,form);
    }
    if(this.modulenameinternal == "Contact") {
      this.SaveContactData(formValues,form);
      this.name="";
    }
    if(this.modulenameinternal == "Company") {
      this.SaveCompanyData(formValues,form);
    }   
  }

  @Output() selectedCoreIdForAI = new EventEmitter();
  @Output() selectedCoreIdForSendTaskList = new EventEmitter();
  @Output() selectedRecordForTypeOfParticipant = new EventEmitter();

  SaveCoreData(formValues, form) {
    this.spinner=true;
     this.markFormGroupTouched(this.myFormGroup);
    this.myFormGroup.markAsPristine();
    this.showRequiredFieldErrors();
    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      this.addCoreVm.FolderID = this.folderId;//17;
      this.addCoreVm.officeID=this.myOfficeID;
    this.addCoreVm.OfficeIDList = this.OfficeIDList;;
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                (formValues[key + 'option'] == undefined || formValues[key + 'option']=='' || formValues[key + 'option']==null)
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option')
          ) {
            if (control != undefined) {
              if (control.fieldNames.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  fieldValue: formValues[key],
                  fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option']=='' || formValues[key + 'option']==null)
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Image') {
            if (formValues[key].length == 0) {
              selectedValues = '';
            } else {
              selectedValues = this.ImageUploadURL; 
            }
          }
          
          let localDateOnly="";
          if(tempList[0].fieldTypeName=='Date')
            {
              let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;
  
              // If selectedDate is a string, set localDateOnly to the string value directly
              if (typeof selectedDate === "string") {
                localDateOnly = selectedDate;
              } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
                // Adjust the date to remove time and prevent timezone shift
                localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                  .toISOString()
                  .split('T')[0]; // Returns 'yyyy-MM-dd'
                formValues[key]= localDateOnly;
              } else {
                localDateOnly = ""; // Set to empty if no valid date
              }
  
            }
         let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: []
          };

          fieldList.push(Fields);
        }
      }

      this.imagelist.forEach((element) => {
        var FieldsImg = {
          FieldID: element.fieldID,
          FieldName: element.fieldName,
          FieldValue: this.ImageUploadURL,
          FieldNameID: null,
        };
        fieldList.push(FieldsImg);
      });
     
      
      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
      let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
      let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
    fieldList = fieldList.filter(function(value, index) { 
        return index != indexDefault; 
    }) ;
    fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    
      this.dynamicArrayAddress.forEach((element,i) => {
        i=i+1;
        let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
        let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City"+i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State"+i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode"+i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country"+i],
          "childFieldType": 1
        })
      fieldList = fieldList.filter(function(value, index) { 
          return index != indexDynamic; 
      }) ;
      fieldList.splice(indexDynamic,0,AddressDynamic);

      });
      fieldList =fieldList.filter(x=> x.FieldName!="Status");

      fieldList.forEach(f => {
        if (f.FieldValue === undefined) {
          f.FieldValue = "";
        }
      });
     
      
      fieldList.forEach(field => {
        if (field.ChildFields && field.ChildFields.length > 0) {
          field.ChildFields.forEach(child => {
            if (child.fieldValue === "") {
              child.fieldValue = null;
            }
          });
        }
      });

      //********** */
      this.addCoreVm.ImageUrl=this.ImageUploadURL;
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.Tags=this.tagvalues;
      this.addCoreVm.TypeID=Number(this.typeId)>0?Number(this.typeId):0;
      this.addCoreVm.medicalCategoryID=Number(this.medicalCategoryID)>0?Number(this.medicalCategoryID):0;
      if(this.mainModuleName == "Core"){
        this.addCoreVm.parentID=Number(this.coreID);
      }
      if(this.mainModuleName == "Contact"){
        this.addCoreVm.ContactId=Number(this.coreID);
        //this.addCompanyVm.CompanyId=Number(this.coreID);
      }
      if(this.mainModuleName == "Company"){
        //this.addCompanyVm.ContactId=Number(this.coreID);
        this.addCoreVm.CompanyId=Number(this.coreID);
      }
      this.addCoreVm.Status=formValues.Status;
      this.loaderService.show();
      //return;      
      this.coreService.saveCoreFeildList(this.addCoreVm).subscribe((response) => {
        if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
              this.closeListing(false);
              this.tags = [];               
              var obj1={
                name:formValues.Name,
                transactionId: this.responseHolder.data.enityID,
                imageUrl: this.addCoreVm.ImageUrl,
                status:formValues.Status,
                typeID:this.typeId,
                email:formValues.Email,
                FromModuleName:'Core'
              } 
              this.selectedCoreIdForAI.emit(obj1);
              if(this.SendingFor=="SendTasklist"){
                this.selectedCoreIdForSendTaskList.emit(obj1);
              }  
              if(this.SendingFor=="TypeofParticipant"){
                this.selectedRecordForTypeOfParticipant.emit(obj1);
              }           
              this.myFormGroup.reset();                
              //this._dataSharingService.sendClickEvent();
              this._dataSharingService.sendSaveUserForCore();
              this.toastr.success('Record save successfully.', '', {
                timeOut: 3000,
              });
            }else{
              this.spinner=false;
              this.loaderService.hide();
              this.EmaildArray=[];
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();
            }
          }else{
            this.spinner=false;
            this.loaderService.hide();
            this.EmaildArray=[];
            this.closeListing(false);
            this.tags = [];
            this.myFormGroup.reset();
          }
        });
    }
  }

markFormGroupTouched(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    if (control instanceof FormGroup) {
      this.markFormGroupTouched(control);
    } else {
      control?.markAsTouched();
    }
  });
}

showRequiredFieldErrors() {
  const requiredFields = [];
  
  // Check all fields in coreFieldList for required validation
  this.coreFieldList.forEach(field => {
    if (field.fieldID === 0 && field.data.length > 1) {
      // Handle grouped fields
      field.data.forEach(grpField => {
        if (grpField.fieldID > 0 && grpField.isRequired) {
          const control = this.myFormGroup.get(grpField.fieldName);
          if (control?.hasError('required')) {
            requiredFields.push(grpField.fieldName);
          }
          
          // Special handling for Address fields
          if (grpField.fieldName === 'Address') {
            if (this.myFormGroup.get('City')?.hasError('required')) {
              requiredFields.push('City');
            }
            if (this.myFormGroup.get('State')?.hasError('required')) {
              requiredFields.push('State');
            }
            if (this.myFormGroup.get('ZipCode')?.hasError('required')) {
              requiredFields.push('Zip Code');
            }
          }
        }
      });
    } else {
      // Handle individual fields
      if (field.isRequired) {
        const control = this.myFormGroup.get(field.fieldName);
        if (control?.hasError('required')) {
          requiredFields.push(field.fieldName);
        }
        
        // Special handling for Address fields
        if (field.fieldName === 'Address') {
          if (this.myFormGroup.get('City')?.hasError('required')) {
            requiredFields.push('City');
          }
          if (this.myFormGroup.get('State')?.hasError('required')) {
            requiredFields.push('State');
          }
          if (this.myFormGroup.get('ZipCode')?.hasError('required')) {
            requiredFields.push('Zip Code');
          }
        }
      }
    }
  });

  // Check dynamic fields
  this.dynamicArray.forEach((element, i) => {
    const emailControl = this.myFormGroup.get(`Email${i + 1}`);
    if (emailControl?.hasError('required')) {
      requiredFields.push(`Email ${i + 1}`);
    }
  });

  this.dynamicArrayPhone.forEach((element, i) => {
    const phoneControl = this.myFormGroup.get(`Phone${i + 1}`);
    if (phoneControl?.hasError('required')) {
      requiredFields.push(`Phone ${i + 1}`);
    }
  });

  this.dynamicArrayAddress.forEach((element, i) => {
    const addressControl = this.myFormGroup.get(`Address${i + 1}`);
    if (addressControl?.hasError('required')) {
      requiredFields.push(`Address ${i + 1}`);
    }
    
    const cityControl = this.myFormGroup.get(`City${i + 1}`);
    if (cityControl?.hasError('required')) {
      requiredFields.push(`City ${i + 1}`);
    }
    
    const stateControl = this.myFormGroup.get(`State${i + 1}`);
    if (stateControl?.hasError('required')) {
      requiredFields.push(`State ${i + 1}`);
    }
    
    const zipControl = this.myFormGroup.get(`ZipCode${i + 1}`);
    if (zipControl?.hasError('required')) {
      requiredFields.push(`Zip Code ${i + 1}`);
    }
  });

  this.dynamicArrayWebsite.forEach((element, i) => {
    const websiteControl = this.myFormGroup.get(`WebSite${i + 1}`);
    if (websiteControl?.hasError('required')) {
      requiredFields.push(`Website ${i + 1}`);
    }
  });

  // Show toastr message with all required fields
  if (requiredFields.length > 0) {
    const uniqueFields = [...new Set(requiredFields)]; // Remove duplicates
    const fieldNames = uniqueFields.join(', ');
    
    this.toastr.error(`Please fill in the following required fields: ${fieldNames}`, 'Validation Error', {
      timeOut: 5000,
      closeButton: true,
      progressBar: true
    });
  }
}

  SaveContactData(formValues, form) {
    this.spinner=true;
    this.myFormGroup.markAsPristine();
    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
      this.addContactVm.DatabaseID = Number(this.databaseId);
      this.addContactVm.UserID = this.currentUser.UID;
      this.addContactVm.OrganizationID = Number(this.organizationId);
      this.addContactVm.FolderID = this.folderId;//20;
      this.addContactVm.officeID=this.myOfficeID;
      this.addContactVm.OfficeIDList=this.OfficeIDList;
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                (formValues[key + 'option'] == undefined || formValues[key + 'option']=='' || formValues[key + 'option']==null)
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option')
          ) {
            if (control != undefined) {
              if (control.fieldNames.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  fieldValue: formValues[key],
                  fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option']==''|| formValues[key + 'option']==null)
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }
          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }
          }
          if (tempList[0].fieldTypeName == 'Image') {
            if (formValues[key].length == 0) {
              selectedValues = '';
            } else {
              selectedValues = this.ImageUploadURL; 
            }
          }
          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var primaryEmail:boolean=false;
          if(this.EmaildArray.length==0){
            primaryEmail=true;
          }
          if(this.EmaildArray.length!=0){
            var primary= this.EmaildArray.filter(x => x.fieldName == key);
            if(primary.length > 0){
             primaryEmail = primary[0].isPrimary;
            }else{
             primaryEmail=false;
            }
          }

          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
                FieldNameID:
                tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: [],
                isPrimary:primaryEmail
          };
          fieldList.push(Fields);
        }
      }

      this.imagelist.forEach((element) => {
        var FieldsImg = {
          FieldID: element.fieldID,
          FieldName: element.fieldName,
          FieldValue: this.ImageUploadURL,
          FieldNameID: null,
        };
        fieldList.push(FieldsImg);
      });
        
      /*************/

      //   Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
      let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
      let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
    fieldList = fieldList.filter(function(value, index) { 
        return index != indexDefault; 
    }) ;
    fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    
      this.dynamicArrayAddress.forEach((element,i) => {
        i=i+1;
        let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
        let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City"+i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State"+i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode"+i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country"+i],
          "childFieldType": 1
        })
      fieldList = fieldList.filter(function(value, index) { 
          return index != indexDynamic; 
      }) ;
      fieldList.splice(indexDynamic,0,AddressDynamic);

      });
      //********** */
      fieldList =fieldList.filter(x=> x.FieldName!="Status");

      // fieldList.forEach(f => {
      //   if (f.FieldValue === undefined) {
      //     f.FieldValue = "";
      //   }
      // });
     
      
      // fieldList.forEach(field => {
      //   if (field.ChildFields && field.ChildFields.length > 0) {
      //     field.ChildFields.forEach(child => {
      //       if (child.fieldValue === "") {
      //         child.fieldValue = null;
      //       }
      //     });
      //   }
      // });
      this.addContactVm.ImageUrl=this.ImageUploadURL;
      this.addContactVm.Fields = fieldList;
      this.addContactVm.Tags=this.tagvalues;
      this.addContactVm.TypeID=Number(this.typeId)>0?Number(this.typeId):0;
      //this.addContactVm.coreID=Number(this.coreID);
      if(this.mainModuleName == "Core"){
        this.addContactVm.coreID=Number(this.coreID);
      }
      if(this.mainModuleName == "Contact"){
        this.addContactVm.ContactId=Number(this.coreID);
        //this.addCompanyVm.CompanyId=Number(this.coreID);
      }
      if(this.mainModuleName == "Company"){
        //this.addCompanyVm.ContactId=Number(this.coreID);
        this.addContactVm.CompanyId=Number(this.coreID);
      }
      if(this.mainModuleName == "FormFolder"){
        //this.addCompanyVm.ContactId=Number(this.coreID);
        this.addContactVm.formFolderID=Number(this.formFolderID);
      }
      if(this.mainModuleName == "Form"){
        //this.addCompanyVm.ContactId=Number(this.coreID);
        this.addContactVm.formID=Number(this.formIDSendToAPI);
      }
      if(this.mainModuleName == "File Manager"){
        //this.addCompanyVm.ContactId=Number(this.coreID);
        this.addContactVm.fileManagerItemID=Number(this.fileManagerItemID);
      }
        this.addContactVm.isShared=this.isShared;
        this.addContactVm.Status=formValues.Status;
        this.loaderService.show();
       // return
        this.coreService.saveContactFeildList(this.addContactVm).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
              this.EmaildArray=[];
              this.closeListing(false);
              this.tags = [];             
                                       
              if(this.mainModuleName == "Forms"){
                this.sendContactId.emit(response.id);
              }              
            
              if(this.mainModuleName != "Forms"){
                this.toastr.success('Record save successfully.', '', {
                  timeOut: 3000,
                });
              }              
              this.contactSaved.emit(true);

              var obj1={
                name:formValues.Name,
                transactionId: response.id,
                imageUrl: this.addContactVm.ImageUrl,
                status:formValues.Status,
                typeID:this.typeId,
                email:formValues.Email,
                FromModuleName:'Contact'
              } 
              if(this.SendingFor=="TypeofParticipant"){
                this.selectedRecordForTypeOfParticipant.emit(obj1);
              }  
              this.myFormGroup.reset();
              this.selectedCoreIdForAI.emit(obj1);

              //
              if(this.SendingFor=="SendTasklist"){
                this.selectedCoreIdForSendTaskList.emit(obj1);
              }              
              //
              this._dataSharingService.sendSaveUserForContact();             
            }else{
              this.spinner=false;
              this.loaderService.hide();
              this.EmaildArray=[];
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();
            }
          }else{
              this.spinner=false;
              this.loaderService.hide();
              this.EmaildArray=[];
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();
          }
        });
    }
  }

  SaveCompanyData(formValues, form) {
    this.spinner=true;
    this.myFormGroup.markAsPristine();
    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
      this.addCompanyVm.DatabaseID = Number(this.databaseId);
      this.addCompanyVm.UserID = this.currentUser.UID;
      this.addCompanyVm.OrganizationID = Number(this.organizationId);
      this.addCompanyVm.FolderID = this.folderId;//19;
      this.addCompanyVm.officeID=this.myOfficeID;
      this.addCompanyVm.OfficeIDList=this.OfficeIDList;
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                (formValues[key + 'option'] == undefined || formValues[key + 'option']==''|| formValues[key + 'option']==null)
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option')
          ) {
            if (control != undefined) {
              if (control.fieldNames.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  fieldValue: formValues[key],
                  fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option']=='' || formValues[key + 'option']==null)
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }
          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }
          }
          if (tempList[0].fieldTypeName == 'Image') {
            if (formValues[key].length == 0) {
              selectedValues = '';
            } else {
              selectedValues = this.ImageUploadURL; 
            }
          }
          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: []
          };
          fieldList.push(Fields);
        }
      }

      this.imagelist.forEach((element) => {
        var FieldsImg = {
          FieldID: element.fieldID,
          FieldName: element.fieldName,
          FieldValue: this.ImageUploadURL,
          FieldNameID: null,
        };
        fieldList.push(FieldsImg);
      });
     
     
      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
      let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
      let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
    fieldList = fieldList.filter(function(value, index) { 
        return index != indexDefault; 
    }) ;
    fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    
      this.dynamicArrayAddress.forEach((element,i) => {
        i=i+1;
        let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
        let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City"+i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State"+i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode"+i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country"+i],
          "childFieldType": 1
        })
      fieldList = fieldList.filter(function(value, index) { 
          return index != indexDynamic; 
      }) ;
      fieldList.splice(indexDynamic,0,AddressDynamic);

      });
      fieldList =fieldList.filter(x=> x.FieldName!="Status");
      //********** */
      this.addCompanyVm.ImageUrl=this.ImageUploadURL
      this.addCompanyVm.Fields = fieldList;
      this.addCompanyVm.Tags=this.tagvalues;
      if(this.mainModuleName == "Core"){
        this.addCompanyVm.parentID=Number(this.coreID);
      }
      if(this.mainModuleName == "Contact"){
        this.addCompanyVm.ContactId=Number(this.coreID);
        //this.addCompanyVm.CompanyId=Number(this.coreID);
      }
      if(this.mainModuleName == "Company"){
        //this.addCompanyVm.ContactId=Number(this.coreID);
        this.addCompanyVm.CompanyId=Number(this.coreID);
      }
      this.addCompanyVm.TypeID=Number(this.typeId)>0?Number(this.typeId):0;
      this.addCompanyVm.Status=formValues.Status;
      this.loaderService.show();
      //return;      
      this.coreService.saveCompanyFeildList(this.addCompanyVm).subscribe((response) => {
       if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();      
              var obj1={
                name:formValues.Name,
                transactionId: response.id,
                imageUrl: this.addCompanyVm.ImageUrl,
                status:formValues.Status,
                typeID:this.typeId,
                email:formValues.Email,
                FromModuleName:'Company'
              } 
              
              if(this.SendingFor=="TypeofParticipant"){
                this.selectedRecordForTypeOfParticipant.emit(obj1);
              }  
              this.selectedCoreIdForAI.emit(obj1);
              this._dataSharingService.sendSaveUserForCompany();        
              this.toastr.success('Record save successfully.', '', {
                timeOut: 3000,
              });
              this.companySaved.emit(true);  
            }else{
              this.spinner=false;
              this.loaderService.hide();
              this.EmaildArray=[];
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();
            }
          }else{
              this.spinner=false;
              this.loaderService.hide();
              this.EmaildArray=[];
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();
          }
        });
    }
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }

  closeListing(message: boolean) {
    this.EmaildArray=[];
    this.ImageUploadURL="";
    this.myFormGroup.reset();
    this.tags = [];
    if(this.SendingFor=="SendTasklist"){
      this.selectedCoreIdForSendTaskList.emit("Close");
      this.closeAdd.emit(message);  
    }else{
      this.closeAdd.emit(message);  
    }
  }

   selectStage(stageId: number) {
    this.medicalCategoryID = stageId;
  }

 

}
